import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IFilterComponent, SearchFilter } from "../../../../infrastructure/iFilter-component";
import { FilterService } from "../../../../services/filter.service";
import { AuthService } from "../../../../services/auth.service";
import { FilterRecordService } from "../../../../services/filter-record.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { PatientSearch } from "../../../../model/patient/patient-search";



@Component({
  selector: 'made-cash-desk-filter',
  templateUrl: './made-cash-desk-filter.component.html',
  styleUrls: ['./made-cash-desk-filter.component.css']
})

export class MadeCashDeskFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private cashDeskService: CashDeskService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      MedicalAppointmentDate: [new Date()],
      Protocol: [''],
      Number: [''],
      Patient: [null],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    let requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters("MadeCashDeskFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters("MadeCashDeskFilterComponent", this.form);
  }

  async search(): Promise<any> {
    return await this.cashDeskService.getPatientMadeCashDeskSearchItem(this.form.controls.Protocol.value,
      this.authService.getCompanyIds(),
      (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null),
      (this.form.controls.Number.value ? this.form.controls.Number.value : null),
      (this.form.controls.MedicalAppointmentDate.value ? <Date>this.form.controls.MedicalAppointmentDate.value : null));
  }

  async ngOnInit() {

  }
}
